import { red } from '@mui/material/colors';
import type { Components, Theme } from '@mui/material/styles';

export const formControlTheme: Components<Theme>['MuiFormControl'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.radio-group,&.checkbox-group': {
        '& .MuiFormLabel-root': {
          color: theme.vars.palette.semantic.text.primary,
          fontSize: '16px',
          fontWeight: 500,
          '&.Mui-error': {
            color: theme.vars.palette.primitive.red[700]
          }
        }
      }
    })
  }
};

export const formControlLabelTheme: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    label: ({ theme }) => ({
      fontSize: '14px',
      color: theme.vars.palette.semantic.text.primary
    })
  }
};

export const formLabelTheme: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    asterisk: {
      color: red[700]
    }
  }
};
